'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CommonUtil = require('./CommonUtil');

var _CommonUtil2 = _interopRequireDefault(_CommonUtil);

var _platform = require('platform');

var _platform2 = _interopRequireDefault(_platform);

var _GlobalData = require('./GlobalData');

var _GlobalData2 = _interopRequireDefault(_GlobalData);

var _WAMConstants = require('../constants/WAMConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompatibilityUtil = function () {
	function CompatibilityUtil() {
		_classCallCheck(this, CompatibilityUtil);
	}

	_createClass(CompatibilityUtil, [{
		key: 'isAppSupported',

		/**
   * Returns true/false based on whether the given app (whose sapCode is passed) is
   * supported on the user's platform or not.
   *
   * @param sapCode Required param.
   * @returns true or false
   */
		value: function isAppSupported(sapCode, olderVersionAppData) {
			var ffcData = _GlobalData2.default.ffcData;

			var appData = olderVersionAppData ? olderVersionAppData : ffcData;
			if (!appData) {
				return false;
			}
			if (!_CommonUtil2.default.isVersionEnabled(appData)) {
				return false;
			}
			var supportedPlatformObjs = void 0;
			var compareMinorVersion = true;
			if (_platform2.default.os && _platform2.default.os.family && _platform2.default.os.family.toLowerCase().indexOf('windows') >= 0) {
				supportedPlatformObjs = appData.platforms.platform.filter(function (platform) {
					return platform.id === 'win32' || platform.id.indexOf('win32') >= 0 || platform.id === 'win64' || platform.id.indexOf('win64') >= 0 || platform.id === 'winarm64' || platform.id.indexOf('winarm64') >= 0;
				});
			} else if (_platform2.default.os && _platform2.default.os.family && _platform2.default.os.family.toLowerCase().indexOf('os x') >= 0) {
				supportedPlatformObjs = appData.platforms.platform.filter(function (platform) {
					return platform.id === 'osx10-64' || platform.id.indexOf('osx10-64') >= 0 || platform.id === 'osx10' || platform.id.indexOf('osx10') >= 0 || platform.id === 'macarm64' || platform.id.indexOf('macarm64') >= 0 || platform.id === 'macu' || platform.id.indexOf('macu') >= 0;
				});
			} else {
				supportedPlatformObjs = [];
			}
			if (supportedPlatformObjs.length > 0) {
				var rangesSupported = [];
				for (var i = 0; i < supportedPlatformObjs.length; i++) {
					var platformObj = supportedPlatformObjs[i];
					var systemCompatibility = platformObj ? platformObj.systemCompatibility : null;
					var operatingSystem = systemCompatibility ? systemCompatibility.operatingSystem : null;
					var range = operatingSystem ? operatingSystem.range : null;

					if (range && range.length > 0) {
						for (var j = 0; j < range.length; j++) {
							var thisRange = range[j];
							var splitRange = thisRange.split('-');
							var lowerLimit = splitRange[0].trim();
							// Convert two part version to three part version (example: 10.9 --> 10.9.0)
							if (!lowerLimit.match(/[0-9]+[.][0-9]+[.][0-9]+/)) {
								if (lowerLimit.match(/[0-9]+[.][0-9]+/)) {
									// Convert two part version to three part version (example: 10.9 --> 10.9.0)
									lowerLimit += '.0';
								} else if (lowerLimit.match(/[0-9]+/)) {
									// Convert one part version to three part version (example: 10 --> 10.0.0)
									lowerLimit += '.0.0';
								}
							}
							var upperLimit = splitRange[1].trim();
							if (!upperLimit) {
								upperLimit = Infinity;
							} else if (!upperLimit.match(/[0-9]+[.][0-9]+[.][0-9]+/)) {
								// Convert two part version to three part version (example: 10.9 --> 10.9.0)
								if (upperLimit.match(/[0-9]+[.][0-9]+/)) {
									upperLimit += '.0';
								} else if (upperLimit.match(/[0-9]+/)) {
									upperLimit += '.0.0';
								}
							}
							rangesSupported.push([lowerLimit, upperLimit]);
						}
					}
				}
				var isSupported = true;
				if (rangesSupported.length !== 0) {
					// only check if we found this info in FFC product
					var userVersion = void 0;
					if (_CommonUtil2.default.isWin()) {
						var agent = navigator.userAgent.toLowerCase();
						// The agent string will contain info in a format like: "windows nt 6.2" or "windows nt 10.0"
						var versionMatch = agent.match(/windows nt ([0-9]+[.][0-9])/);
						if (versionMatch && versionMatch.length > 1) {
							userVersion = versionMatch[1];
						}
					} else {
						userVersion = _platform2.default.os.version;
					}
					if (!userVersion) {
						return true;
					}
					if (!userVersion.match(/[0-9]+[.][0-9]+[.][0-9]+/)) {
						if (userVersion.match(/[0-9]+[.][0-9]+/)) {
							// Convert two part version to three part version (example: 10.9 --> 10.9.0)
							userVersion += '.0';
							compareMinorVersion = false;
						} else if (userVersion.match(/[0-9]+/)) {
							// Convert one part version to three part version (example: 10 --> 10.0.0)
							userVersion += '.0.0';
							compareMinorVersion = false;
						}
					}
					for (var _i = 0; _i < rangesSupported.length; _i++) {
						var supportedRange = rangesSupported[_i];
						isSupported = _CommonUtil2.default.isAGreaterThanEqualToB(userVersion, supportedRange[0], compareMinorVersion) && _CommonUtil2.default.isAGreaterThanEqualToB(supportedRange[1], userVersion, compareMinorVersion);
						if (isSupported) {
							return isSupported;
						}
					}
				}
				return isSupported;
			}
			return false;
		}
	}, {
		key: 'getSupportedAppVersion',
		value: function getSupportedAppVersion(sapCode) {
			var ffcData = _GlobalData2.default.ffcData;

			if (ffcData) {
				var appVersion = ffcData.version;
				if (!this.isAppSupported(sapCode) && this.isAnyOlderVersionSupported(sapCode)) {
					appVersion = _GlobalData2.default.olderSupportedVersion;
				}
				return appVersion;
			}
			return null;
		}
	}, {
		key: 'isAnyOlderVersionSupported',
		value: function isAnyOlderVersionSupported(sapCode) {
			var allVersionsFFCProductList = _GlobalData2.default.allVersionsFFCProductList;

			if (allVersionsFFCProductList) {
				for (var i = allVersionsFFCProductList.length - 1; i >= 0; i--) {
					if (this.isAppSupported(sapCode, allVersionsFFCProductList[i])) {
						_GlobalData2.default.olderSupportedVersion = allVersionsFFCProductList[i].version;
						return true;
					}
				}
				return false;
			}
			return true;
		}
	}, {
		key: 'setFFCDataAndCheckCompatibility',
		value: function setFFCDataAndCheckCompatibility(sapCode, allVersionFFCData) {
			var incompatible = _WAMConstants.compatibilityStrings.incompatible,
			    currentSupported = _WAMConstants.compatibilityStrings.currentSupported,
			    previousSupported = _WAMConstants.compatibilityStrings.previousSupported;

			_GlobalData2.default.allVersionsFFCProductList = allVersionFFCData;
			_GlobalData2.default.ffcData = allVersionFFCData[allVersionFFCData.length - 1];
			if (this.isAppSupported(sapCode)) {
				currentSupported.supportedAppVersion = _GlobalData2.default.ffcData.version;
				return currentSupported;
			} else {
				var supportedVersion = this.getSupportedAppVersion(sapCode);
				if (supportedVersion && this.isAnyOlderVersionSupported(sapCode)) {
					previousSupported.supportedAppVersion = supportedVersion;
					return previousSupported;
				} else {
					return incompatible;
				}
			}
		}
	}]);

	return CompatibilityUtil;
}();

exports.default = new CompatibilityUtil();